export default __webpack_public_path__ + "static/media/aakash-logo.27a40e9d.png";